






























































import { Component, Vue } from 'vue-property-decorator';

import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import { NotificationModel } from '@/models/notification';
import orderService from '@/services/order-service';
import commonServices from '@/services/common-services';

@Component({})
export default class Notification extends Vue {
    private eventEmit = {
        totalNotification: 'totalNotification'
    };
    private tab = {
        noti: 'noti',
        msg: 'msg'
    }
    private timer: any;
    private selectedTab = this.tab.noti;
    private pageSettings = {
        rowPerPage: 10,
        pageSize: 3,
        pageIndex: 1,
        total: 0,
    };
    private listNotification: NotificationModel[] = [];
    private top5Notifications = {
        global_total: 0,
        public_total: 0,
        global_items: [],
        public_items: []
    };
    private isInitialized = false;
    private seenMessageIds: { [key: number]: boolean } = {};
    private isLoading = false;
    private onSelectedTab(tab: any) {
        this.selectedTab = tab;
    }
    private closePopup() {
      // Tìm dropdown và trigger sự kiện đóng
      const dropdown = document.querySelector('.headermenu div.btn-group.open');
      if (dropdown) {
        dropdown.classList.remove("open");
      }
    }
    private async created() {
        this.timer = setInterval(() => {
            this.loadNotification();
        }, APP_CONFIG.notifyRefreshTime * 1000);

        eventBus.$on(APP_CONFIG.eventBusAction.reloadNotification, () => {
            this.loadNotification();
        });

        this.loadNotification();
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    private async loadNotification() {
        if(document.hidden) {
            return;
        }
        this.listNotification = [];
        this.isLoading = true;
        const filter = [{ column: 'Status', value: [0,2], condition: 'in' }];
        const result = await commonServices.getNotification(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filter, true);
        if (result && result.status === 200 && result.data.status === 200) {
            const data = result.data.data;
            const newPublicItems = (data && data.public_items) ? data.public_items : [];

            if (newPublicItems && newPublicItems.length > 0) {
                // Tìm các tin nhắn chưa đọc (Status == 0) mà chưa được hiển thị popup toast trong session này
                let emitted = false;
                for (let i = 0; i < newPublicItems.length; i++) {
                    const item: any = newPublicItems[i];
                    if (item && item.ID && item.Status === 0) {
                        const sessionKey = 'vbi_toasted_notif_' + item.ID;
                        const alreadyToasted = sessionStorage.getItem(sessionKey);
                        if (!alreadyToasted && !this.seenMessageIds[item.ID]) {
                            this.seenMessageIds[item.ID] = true;
                            sessionStorage.setItem(sessionKey, '1');
                            if (!emitted) {
                                this.$emit('newMessage', item);
                                emitted = true;
                            }
                        }
                    }
                }
            }
            this.isInitialized = true;

            this.top5Notifications = data;
            // Nếu có tin nhắn mới mà không có thông báo đơn, tự động chọn tab Tin nhắn
            if (this.top5Notifications.public_total > 0 && this.top5Notifications.global_total === 0 && this.selectedTab === this.tab.noti) {
                this.selectedTab = this.tab.msg;
            }

            if(this.listNotification.length > 0) {
                this.$emit(this.eventEmit.totalNotification, {global_total: 0, public_total: 0});
            } else {
                this.$emit(this.eventEmit.totalNotification, {global_total: this.top5Notifications.global_total, public_total: this.top5Notifications.public_total});
            }
            
        }
        this.isLoading = false;
    }

    private async handleScroll(event: any) {
        // const scrollHeight = event.target.scrollHeight;
        // const scrollPosition = event.target.scrollTop;
        // if (scrollPosition > scrollHeight - 350) {
        //     this.pageSettings.pageIndex++;
        //     this.loadNotification();
        // }
    }

    private async onReadNotification(notif: any) {
        try {
            commonServices.updateStatusNotification(notif.ID, { Status: 1 }).then(result  => {
                if (result && result.status === 200 && result.data.status === 200) {
                    this.loadNotification();
                }
            });
            if(!notif.OrderID) {
                return;
            }
            if (notif.OrderType == APP_CONFIG.ORDER_TYPE.deposit) {
                this.$router.push({ name: 'deposit-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 6) {
                this.$router.push({ name: 'payauthority-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 5) {
                this.$router.push({ name: 'payservice-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 4) {
                const result = await orderService.getComplainById(notif.OrderID);
                if (result && result.status === 200 && result.data.status === 200) {
                    let complain = result.data.data;
                    if(complain.OrderType == 1) {
                        this.$router.push({ name: 'detail-order-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if (complain.orderType == 2) {
                        this.$router.push({ name: 'detail-deposit-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if(complain.orderType == 3 || complain.OrderType == 3) {
                        this.$router.push({ name: 'detail-payauthority-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if(complain.orderType == 5 || complain.OrderType == 5) {
                        const routeData = this.$router.resolve({ name: 'detail-quotation-complain', params: { orderId: complain.OrderID.toString(), complainId: complain.ID.toString(), orderType: '5' } });
                        window.open(routeData.href, '_blank');
                    }
                }
            } else if(this.isQuotationNotif(notif)) {
                const routeData = this.$router.resolve({ name: 'quotation-detail', params: { id: notif.OrderID.toString() }, query: { tab: 'chat' } });
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({ name: 'order-detail', params: { orderId: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            }
        } catch {
            return false;
        }
    }

    public isQuotationNotif(notif: any): boolean {
        if (!notif || notif.OrderType == 4) return false;
        return notif.OrderType == 100 || notif.OrderType == 7 || notif.OrderType == 8 ||
            Boolean(notif.Message && notif.Message.toLowerCase().includes('báo giá'));
    }
}
